





















































import { computed, defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { url } from '~/utils';
import { sendGaEvent } from '~/utils/ga';
import { NewsItemOfSlider } from '~/types/modules/top';
import type { SwiperOptions } from 'swiper';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  props: {
    items: {
      type: Array as PropType<NewsItemOfSlider[]>,
      default: () => [],
    },
  },
  setup(props) {
    const isSliderReady = ref(false);
    const swiperOptions = computed(
      (): SwiperOptions => ({
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        speed: 750,
        autoplay:
          props.items.length > 1
            ? {
                delay: 5000,
                disableOnInteraction: false,
              }
            : false,
        navigation: {
          nextEl: '#top-news-slider-next',
          prevEl: '#top-news-slider-prev',
        },
        on: {
          init() {
            isSliderReady.value = true;
          },
        },
      })
    );

    const formatDate = (date: string) => {
      return dayjs(date).tz('Asia/Tokyo').format('YYYY.M.D');
    };

    return {
      url,
      sendGaEvent,
      isSliderReady,
      swiperOptions,
      formatDate,
    };
  },
});
